export const makeSquareImage = (
  base64Image: string,
  focusOn: string = 'min'
): Promise<string> => {
  return new Promise(resolve => {
    const img = new Image();
    img.src = base64Image;

    img.onload = () => {
      const size =
        focusOn === 'min'
          ? Math.min(img.width, img.height)
          : Math.max(img.width, img.height);

      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;

      const ctx = canvas.getContext('2d');
      if (!ctx) return resolve(base64Image);

      const offsetX = (img.width - size) / 2;
      const offsetY = (img.height - size) / 2;

      ctx.drawImage(img, offsetX, offsetY, size, size, 0, 0, size, size);
      resolve(canvas.toDataURL('image/jpeg', 1.0));
    };
  });
};

export const getImageDimensionsForCrop = (
  img: HTMLImageElement
): {
  size: number;
  center: { x: number; y: number } | null;
} => {
  let size = Math.min(img.width, img.height);
  if (size >= 160) {
    size = 160;
  } else if (size >= 100) {
    size = 100;
  }
  const center = { x: img.width / 2 - size / 2, y: img.height / 2 - size / 2 };
  return { size, center };
};

// Utility to un-mirror a base64 image (flip horizontally)
export const unMirrorImage = (imageData: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.onload = function () {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject('No canvas context');
      ctx.save();
      ctx.translate(img.width, 0);
      ctx.scale(-1, 1);
      ctx.drawImage(img, 0, 0);
      ctx.restore();
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = reject;
    img.src = imageData;
  });
};

export const dataURLtoFile = (dataUrl: string, filename: string) => {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};
